export default __webpack_public_path__ + "8a9d15fde91401424c3843203bf60994.png";